// src/components/ai/copilot/AiGeneratedDraftEditor.js
import React from 'react';

/**
 * Editable textarea for AI-generated draft content.
 * Shows a "Modified from AI draft" badge when the instructor has edited the text.
 * The edit/unedited state is tracked by the parent and passed in as `hasBeenEdited`.
 *
 * Props:
 *   value           — string — current (possibly edited) text
 *   onChange        — (text: string) => void
 *   hasBeenEdited   — bool — parent tracks whether text differs from AI original
 *   label           — string — shown above textarea
 *   rows            — number (default 8)
 *   placeholder     — string
 *   disabled        — bool
 */
function AiGeneratedDraftEditor({
  value = '',
  onChange,
  hasBeenEdited = false,
  label = 'Draft — edit before using',
  rows = 8,
  placeholder = 'AI draft will appear here…',
  disabled = false,
}) {
  return (
    <div>
      <div className="flex items-center justify-between gap-3">
        <label className="text-xs font-semibold text-slate-500">{label}</label>
        {hasBeenEdited ? (
          <span className="rounded-full bg-amber-50 px-2 py-0.5 text-xs font-medium text-amber-600">
            Modified from AI draft
          </span>
        ) : value ? (
          <span className="rounded-full bg-violet-50 px-2 py-0.5 text-xs font-medium text-violet-500">
            AI draft — review before using
          </span>
        ) : null}
      </div>
      <textarea
        className="mt-2 w-full rounded-2xl border border-slate-300 px-4 py-3 text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-violet-300 disabled:bg-slate-50 disabled:text-slate-400"
        rows={rows}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
      />
    </div>
  );
}

export default AiGeneratedDraftEditor;
